var map = {
	"./defaultpic.svg": 7322,
	"./empty-order.svg": 6902,
	"./flags/afghanistan.svg": 8862,
	"./flags/argentina.svg": 8096,
	"./flags/austria.svg": 9530,
	"./flags/azerbaijan.svg": 9833,
	"./flags/belgium.svg": 9888,
	"./flags/belorussia.svg": 5166,
	"./flags/bolivia.svg": 2254,
	"./flags/brasil.svg": 5973,
	"./flags/bulgaria.svg": 5747,
	"./flags/burkinafaso.svg": 4334,
	"./flags/cameroon.svg": 9550,
	"./flags/canada.svg": 5365,
	"./flags/chad.svg": 7167,
	"./flags/china.svg": 8883,
	"./flags/colombia.svg": 964,
	"./flags/croatia.svg": 2589,
	"./flags/cyprus.svg": 3014,
	"./flags/czech.svg": 6125,
	"./flags/denmark.svg": 1570,
	"./flags/ecuador.svg": 7607,
	"./flags/egypt.svg": 5215,
	"./flags/estonia.svg": 1163,
	"./flags/finland.svg": 3498,
	"./flags/france.svg": 3273,
	"./flags/gambia.svg": 3504,
	"./flags/georgia.svg": 8019,
	"./flags/germany.svg": 2956,
	"./flags/ghana.svg": 3795,
	"./flags/greece.svg": 7414,
	"./flags/guinea bissau.svg": 360,
	"./flags/guinea.svg": 2279,
	"./flags/haiti.svg": 7139,
	"./flags/honduras.svg": 4333,
	"./flags/hongkong.svg": 290,
	"./flags/india.svg": 9869,
	"./flags/indonesia.svg": 4120,
	"./flags/iran.svg": 5039,
	"./flags/iraq.svg": 7869,
	"./flags/ireland.svg": 5095,
	"./flags/israel.svg": 1273,
	"./flags/italy.svg": 978,
	"./flags/ivory.svg": 8214,
	"./flags/jordan.svg": 5213,
	"./flags/kazakhstan.svg": 1175,
	"./flags/kenya.svg": 1429,
	"./flags/latvia.svg": 9957,
	"./flags/liberia.svg": 3794,
	"./flags/lithuania.svg": 9355,
	"./flags/malawi.svg": 1573,
	"./flags/malaysia.svg": 5010,
	"./flags/mali.svg": 3074,
	"./flags/mauritania.svg": 9948,
	"./flags/mexico.svg": 9177,
	"./flags/moldova.svg": 2649,
	"./flags/mongolia.svg": 3022,
	"./flags/morocco.svg": 3242,
	"./flags/nepal.svg": 7888,
	"./flags/netherlands.svg": 7420,
	"./flags/nicaragua.svg": 3872,
	"./flags/nigeria.svg": 5377,
	"./flags/northmacedonia.svg": 8754,
	"./flags/pakistan.svg": 9067,
	"./flags/peru.svg": 4429,
	"./flags/philippines.svg": 6605,
	"./flags/poland.svg": 1664,
	"./flags/portugal.svg": 9157,
	"./flags/romania.svg": 2648,
	"./flags/russia.svg": 9225,
	"./flags/salvador.svg": 410,
	"./flags/saudiarabia.svg": 3936,
	"./flags/senegal.svg": 7689,
	"./flags/serbia.svg": 6927,
	"./flags/sierraleone.svg": 4321,
	"./flags/singapore.svg": 7866,
	"./flags/spain.svg": 4460,
	"./flags/srilanka.svg": 5345,
	"./flags/sudan.svg": 1966,
	"./flags/sweden.svg": 2998,
	"./flags/switzerland.svg": 527,
	"./flags/taiwan.svg": 8567,
	"./flags/tajikistan.svg": 2857,
	"./flags/thailand.svg": 6197,
	"./flags/togo.svg": 2726,
	"./flags/tunis.svg": 4049,
	"./flags/turkey.svg": 7233,
	"./flags/uganda.svg": 1132,
	"./flags/ukraine.svg": 8138,
	"./flags/united_kingdom.svg": 1340,
	"./flags/usa.svg": 7067,
	"./flags/uzbekistan.svg": 1636,
	"./flags/venezuela.svg": 366,
	"./flags/vietnam.svg": 6092,
	"./flags/yemen.svg": 3742,
	"./flags/zambia.svg": 9385,
	"./foot/coin-1.png": 4787,
	"./foot/coin-2.png": 3032,
	"./foot/coin-3.png": 9102,
	"./foot/coin-4.png": 1606,
	"./foot/coin-5.png": 9164,
	"./footer-logo.svg": 8105,
	"./icons/3223.svg": 9671,
	"./icons/airbnb.svg": 7248,
	"./icons/alibaba.svg": 2259,
	"./icons/aliexpress.svg": 526,
	"./icons/amazon.svg": 8584,
	"./icons/aol.svg": 3828,
	"./icons/apple.svg": 1548,
	"./icons/auto_ru.svg": 1942,
	"./icons/badoo.svg": 4875,
	"./icons/baidu.svg": 3851,
	"./icons/bigo_live.svg": 1782,
	"./icons/blablacar.svg": 9823,
	"./icons/bolt.svg": 8628,
	"./icons/burgerking.svg": 8082,
	"./icons/careem.svg": 9967,
	"./icons/cliqq.svg": 6799,
	"./icons/dent.svg": 3456,
	"./icons/depop.svg": 5474,
	"./icons/discord.svg": 8028,
	"./icons/douban.svg": 7116,
	"./icons/douyu.svg": 1269,
	"./icons/ebay.svg": 4201,
	"./icons/faceit.svg": 5573,
	"./icons/fetlife.svg": 3899,
	"./icons/g2a.svg": 1464,
	"./icons/gameflip.svg": 5194,
	"./icons/gett.svg": 4513,
	"./icons/glovo.svg": 5678,
	"./icons/google.svg": 3984,
	"./icons/hezzl.svg": 9844,
	"./icons/homeaway.svg": 9264,
	"./icons/hotmail.svg": 8813,
	"./icons/hqtrivia.svg": 3113,
	"./icons/icq.svg": 9691,
	"./icons/imo.svg": 7379,
	"./icons/inboxlv.svg": 6567,
	"./icons/instagram.svg": 673,
	"./icons/jiayuan.svg": 8568,
	"./icons/kakaotalk.svg": 6772,
	"./icons/keybase.svg": 2659,
	"./icons/kwai.svg": 5931,
	"./icons/linemessenger.svg": 6735,
	"./icons/linkedin.svg": 8500,
	"./icons/livescore.svg": 6729,
	"./icons/lyft.svg": 623,
	"./icons/maplesea.svg": 4044,
	"./icons/meetme.svg": 3813,
	"./icons/michat.svg": 2273,
	"./icons/microsoft.svg": 9852,
	"./icons/mymusictaste.svg": 1950,
	"./icons/naver.svg": 3785,
	"./icons/netease.svg": 1191,
	"./icons/netflix.svg": 1671,
	"./icons/nike.svg": 4090,
	"./icons/nttgame.svg": 8704,
	"./icons/olacabs.svg": 9705,
	"./icons/olx.svg": 4190,
	"./icons/oracle.svg": 6944,
	"./icons/others.svg": 6560,
	"./icons/periscope.svg": 9056,
	"./icons/plenty_of_fish.svg": 5399,
	"./icons/seagm.svg": 197,
	"./icons/sheerid.svg": 3709,
	"./icons/shopee.svg": 9585,
	"./icons/skout.svg": 7171,
	"./icons/snapchat.svg": 6322,
	"./icons/steam.svg": 8650,
	"./icons/tantan.svg": 177,
	"./icons/taobao.svg": 666,
	"./icons/telegram.svg": 4588,
	"./icons/tencentqq.svg": 1217,
	"./icons/ticketmaster.svg": 9898,
	"./icons/tiktok.svg": 5519,
	"./icons/tinder.svg": 5354,
	"./icons/truecaller.svg": 9841,
	"./icons/twitter.svg": 3961,
	"./icons/uber.svg": 1430,
	"./icons/viber.svg": 4827,
	"./icons/wechat.svg": 5655,
	"./icons/weibo.svg": 5331,
	"./icons/whatsapp.svg": 3881,
	"./icons/whatsaround.svg": 6963,
	"./icons/wolt.svg": 1448,
	"./icons/yahoo.svg": 5777,
	"./icons/yalla.svg": 4408,
	"./icons/yandeks.svg": 3490,
	"./icons/zadarma.svg": 2026,
	"./icons/zenly.svg": 5728,
	"./icons/zoho.svg": 7291,
	"./logo.svg": 9574,
	"./wallet/bitkeep-img01.jpg": 316,
	"./wallet/bitkeep-img02.jpg": 1168,
	"./wallet/bitkeep.jpg": 294,
	"./wallet/bitpie-img01.jpg": 1703,
	"./wallet/bitpie-img02.jpg": 7041,
	"./wallet/bitpie.jpg": 2225,
	"./wallet/imtoken-img01.jpg": 8458,
	"./wallet/imtoken.png": 2774,
	"./wallet/metamask-img01.jpg": 4885,
	"./wallet/metamask-img02.jpg": 4456,
	"./wallet/metamask.png": 8654,
	"./wallet/okex-img01.jpg": 3668,
	"./wallet/okex.png": 9998,
	"./wallet/tokenpocket-img01.jpg": 2177,
	"./wallet/tokenpocket.png": 6320,
	"./wallet/tronlink-img01.jpg": 5477,
	"./wallet/tronlink.jpg": 3390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;